import { render } from "./payroll-detail.vue?vue&type=template&id=54762b65&scoped=true&ts=true"
import script from "./payroll-detail.vue?vue&type=script&lang=ts"
export * from "./payroll-detail.vue?vue&type=script&lang=ts"

import "./payroll-detail.vue?vue&type=style&index=0&id=54762b65&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54762b65"]])

export default __exports__